define('models/accounts/account',["backbone",
     "models/shared/settings/settingvalue_collection",
     "models/shared/bankaccount/bankaccount",
     "models/accounts/accountattribute_collection",
     "models/accounts/accountsummary_collection",
     "models/shared/lookups/systext"
], function (Backbone, AccountSettingList, BankAccount, AccountAttributeList,AccountSummaryList) {
    var Account = Backbone.Model.extend({
        urlRoot: function () {

            if (this.instanceURL)
                return this.instanceURL;
            var url = pf.accountsURL;
            if (this.ID != null) {
                url += "/" + this.ID;
            }
            return url;
        },
        initialize: function (options) {
            options = options || {};
            this.instanceURL = options.instanceURL;
            this.accountBalance = options.AB;
            this.ID = options.ID;
        },
        defaults: {
            accountBalance: 0,
            bankAccount: new BankAccount({ parse: true })
        },
        parse: function (data) {
            //_gaq.push(['_trackEvent', 'Consumer', 'Account', data.AN + '-' + data.AGID, null, null]);
            gAnalytics('Account', data.AN + '-' + data.AGID, 'Clicked');

            var response = {};
            response.accountName = data.AN;
            response.parentAccountName = data.PAN;
            response.managedBy = data.MB;
            response.accountGUID = data.AGID;
            response.accountGUIDT = data.AGIDT;
            response.accountID = data.AID;
            response.addressLine1 = data.A1;
            response.addressLine2 = data.A2;
            response.city = data.C;
            response.state = data.S;
            response.zipCode = data.Z;
            response.zipCodeID = data.ZID;
            response.country = data.CN;
            response.parentAccountID = data.PAID;
            response.parentAccountGUID = data.PAGID;
            response.accountTypeID = data.ATID;
            response.accountCategoryID = data.ACID;
            response.accountCategory = data.ACT;
            response.accountCode = data.AC;
            response.certificationTypeID = data.CTID;
            response.certificationType = data.CTT;
            response.accountStatusTypeID = data.ASTID;
            response.photo = buildImageURL(pf.enums.entityTypeCodeEnum.Account, data.AGID, pf.enums.imageTypeGUIDEnum.Thumbnail, data.P);
            response.logo = buildImageURL(pf.enums.entityTypeCodeEnum.Account, data.AGID, pf.enums.imageTypeGUIDEnum.Thumbnail, data.L);
            response.shortDescription = data.SD;
            response.description = data.D;
            response.financial = data.F;
            response.financialTypeID = data.FTID;
            response.financialType = data.FTT;
            response.targetAmount = data.TA;
            response.targetAmountDueBy = data.TADB;
            response.accountBalance = data.AB;
            response.startDT = data.SDT;
            response.endDT = data.EDT;
            response.taxIDLastFour = data.TID;
            response.game = data.G;
            response.Internal = data.I;
            response.Private = data.PT;
            response.urlTerm = data.UT;
            response.twitterAddress = data.TAD;
            response.facebookURL = data.FBU;
            response.googleURL = data.GU;
            response.minPercent = data.MP;
            response.PFSalesPersonID = data.PFSP;
            response.enabled = data.E;
            response.disabledDT = data.DDT;
            response.disabledByUserID = data.DUID;
            response.createdDT = data.CDT;
            response.createdByUserID = data.CUID;
            response.lastUpdateDT = data.LUDT;
            response.participantCount = data.PC;
            response.allocatorsCount = data.ALC;
            response.invitationsSent = data.IS;
            response.accountType = data.ATY;
            response.accountStatusType = data.AST;
            response.isMember = data.IM;
            response.isEditable = data.IE;
            //response.TotalContributors = data.TC;
            response.TotalParticipants = data.TP;
            //response.InvitationsSend = data.INS;
            //response.InvitationsAccepted = data.INA;
            response.stateID = data.SID;
            response.AmountToTransfer = data.AT;
            response.AccountNameTo = data.ANT;
            response.Recipient = data.R;
            if (!data.ASTG)
                data.ASTG = new AccountSettingList({ ID: data.AGID, SF: pf.enums.settingFor.Account });
            else
                data.ASTG.SF = pf.enums.settingFor.Account;

            //if (data.ASTG && data.ASTG.length && data.ASTG.length > 0 && data.ASTG[0] && data.ASTG[0].SID) {
            //    for (var x in data.ASTG) {
            //        if (data.ASTG[x].SID == 28) {
            //            response.financial = data.ASTG[x].SV == 1 ? true : false;
            //        }
            //    }
            //}
            response.AccountSettings = new AccountSettingList(data.ASTG, { parse: true });
            response.stateID = data.SID;
            response.bankAccount = new BankAccount(data.BA, { parse: true });
            response.bankAccount = data.BA;

            response.MaximumPossibleAmount = data.MPA;
            response.PendingTransactionBalance = data.PTB;

            response.AccountAttributeList = new AccountAttributeList(data.AAL, { parse: true });

            response.CertificationImageName = data.CIN;
            if (data.CTID == 1 || data.CTID == 2)
                response.CertificateURL = "/img/" + data.CIN + ".png";
            else
                response.CertificateURL = "";
            response.managedByGUID = data.MBID;
            response.ParticipantStatusID = data.PSID;
            response.IsSpendingAccount = data.ISA;
            response.MinCauseTransferAmount = data.MinCTA;
            response.MaxCauseTransferAmount = data.MaxCTA;

            response.managerEmailAddress = data.ME;
            response.managerEmailGUID = data.MEGD;
            response.CanCompanionManage = data.CCM;
            response.NotificationDays = data.NDS;
            response.CanPrimaryManage = data.CPM;
            response.AccountSummaryList = new AccountSummaryList(data.ASL, { parse: true });
            response.CompanionFirstName = data.CFN;
            response.CompanionLastName = data.CLN;
            response.CIPStatus = data.CIPS;
            response.CompanionAccess = data.ACA;
            response.AllocationEnabled = data.AE;
            return response;
        },

        validation: {
            accountName: {
                required: true,
                msg: sysText['FV']['required']['causeName'],
            },
            accountTypeID: {
                required: true,
                fn: function (value, attr, computedState) {
                    if (value < 0) {
                        var errmsg = sysText['FV']['required']['causeType'];
                        return errmsg;
                    }
                }
            },
            accountCategoryID: {
                required: true,
                fn: function (value, attr, computedState) {
                    if (value < 0) {
                        var errmsg = sysText['FV']['required']['causeCategory'];
                        return errmsg;
                    }
                }
            },
            stateID: {
                required: true,
                msg: sysText['FV']['required']['state'],
                fn: function (value, attr, computedState) {
                    if (value < 0) {
                        var errmsg = sysText['FV']['required']['state'];
                        return errmsg;
                    }
                }
            },
            //city: {
            //    required: true,
            //    msg: sysText['FV']['required']['city'],
            //    //fn: function (value, attr , computedState) {
            //    //    var pattern = new RegExp(/^[a-zA-Z. ]+$/i);
            //    //    if (!pattern.test(city))
            //    //    {
            //    //        var errmsg = sysText['FV']['invalid']['value'];
            //    //        return errmsg;
            //    //    }

            //    //    if (city == null || city == "") {
            //    //        var errmsg = sysText['FV']['required']['city'];
            //    //        return errmsg;
            //    //    }
            //    //}
            //},
            //description: {
            //    fn: function (value, attr, computedState) {
            //        var pattern = new RegExp(/^[a-zA-Z0-9.:,&@$;-]+$/i);
            //        if (!pattern.test(description)) {
            //            var errmsg = sysText['FV']['invalid']['value'];
            //            return errmsg;
            //        }
            //    }
            //},
            urlTerm: {
                fn: function (value, attr, computedState) {
                    if (value == null || value == "") {
                        var errmsg = sysText['FV']['required']['causeURL'];
                        return errmsg;
                    }
                }
            }

        },
        save: function (currentAttributes, options) {
            options = options || {};
            currentAttributes = currentAttributes || {};

            var data = {};

            data.AN = this.attributes.accountName;
            data.PAN = this.attributes.parentAccountName;
            data.MB = this.attributes.managedBy;
            data.AGID = this.attributes.accountGUID;
            data.AGIDT = this.attributes.accountGUIDT;
            data.AID = this.attributes.accountID;
            data.A1 = this.attributes.addressLine1;
            data.A2 = this.attributes.addressLine2;
            data.C = this.attributes.city;
            data.S = this.attributes.state;
            data.SID = this.attributes.stateID;
            data.Z = this.attributes.zipCode;
            data.ZID = this.attributes.zipCodeID;
            data.CN = this.attributes.country;
            data.PAID = this.attributes.parentAccountID;
            data.PAGID = this.attributes.parentAccountGUID;
            data.ATID = this.attributes.accountTypeID;
            data.ACID = this.attributes.accountCategoryID;
            data.AC = this.attributes.accountCode;
            data.CTID = this.attributes.certificationTypeID;
            data.ASTID = this.attributes.accountStatusTypeID;
            data.P = getImageFileName(this.attributes.photo);
            data.L = getImageFileName(this.attributes.logo);
            data.SD = this.attributes.shortDescription;
            data.D = this.attributes.description;
            data.F = this.attributes.financial;
            data.FTID = this.attributes.financialTypeID;
            data.TA = this.attributes.targetAmount;
            data.TADB = this.attributes.targetAmountDueBy;
            data.AB = this.attributes.accountBalance;

            data.SDT = this.attributes.startDT;
            data.EDT = this.attributes.endDT;
            data.G = this.attributes.game;
            data.I = this.attributes.Internal;
            data.PT = this.attributes.Private;
            data.UT = this.attributes.urlTerm;
            data.TAD = this.attributes.twitterAddress;
            data.FBU = this.attributes.facebookURL;
            data.GU = this.attributes.googleURL;
            data.MP = this.attributes.minPercent;
            data.PFSP = this.attributes.PFSalesPersonID;
            data.E = this.attributes.enabled;
            data.DDT = this.attributes.disabledDT;
            data.DUID = this.attributes.disabledByUserID;
            data.CDT = this.attributes.createdDT;
            data.CUID = this.attributes.createdByUserID;
            data.LUDT = this.attributes.lastUpdateDT;
            data.PC = this.attributes.participantCount;
            data.ALC = this.attributes.allocatorsCount;
            data.IS = this.attributes.invitationsSent;
            data.ATY = this.attributes.accountType;
            data.AST = this.attributes.accountStatusType;
            data.IM = this.attributes.isMember;
            data.IE = this.attributes.isEditable;
            data.BA = this.attributes.bankAccount;
            data.AT = this.attributes.amountToTransfer;
            data.MPA = this.attributes.MaximumPossibleAmount;
            data.ANT = this.attributes.AccountNameTo;
            data.R = this.attributes.Recipient;
           
            data.AAL = this.attributes.AccountAttributeList;
            data.CIN = this.attributes.CertificationImageName;
            data.CertificateURL = this.attributes.CertificateURL;
            data.MBID = this.attributes.managedByGUID;
            data.MinCTA = this.attributes.MinCauseTransferAmount;
            data.MaxCTA = this.attributes.MaxCauseTransferAmount;

            data.ME = this.attributes.managerEmailAddress;
            data.MEGD = this.attributes.managerEmailGUID;
            data.ACA = this.attributes.CompanionAccess;

            this.attributes = data;

            return Backbone.Model.prototype.save.call(this, this.attributes, options);
        }
    });
    return Account;
});

